import { lazy } from 'react';

const loadPageApplicationSettings = () => import('./PageApplicationSettings');
// eslint-disable-next-line import/prefer-default-export
export const PageApplicationSettings = lazy(loadPageApplicationSettings);
